import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import { toolkitCx } from "../../../constants";
import { ArrowRightIcon, ArrowTopRightIcon } from "../../../icons";
export const renderArrow = (arrow, size = "") => {
    if (arrow === "top-right") {
        return (_jsx(ArrowTopRightIcon, { className: cx("fill-current group-hover:-translate-y-0.5 group-hover:translate-x-0.5", {
                "h-3 w-3": ["xs", "sm"].includes(size),
                "h-4 w-4": size === "base",
                "h-5 w-5": ["lg", "xl"].includes(size),
            }, toolkitCx.layout.transition.transform) }));
    }
    if (arrow === "right") {
        return (_jsx(ArrowRightIcon, { className: cx("self-center fill-current group-hover:translate-x-0.5", {
                "h-3 w-3": size === "xs",
                "h-4 w-4": size === "sm",
                "h-5 w-5": size === "base",
                "h-6 w-6": ["lg", "xl"].includes(size),
            }, toolkitCx.layout.transition.transform) }));
    }
    return null;
};
//# sourceMappingURL=Link.shared.js.map